<template>
    <div id="account">
        <header>
            Personal
            <router-link :to="{ name: 'Account' }"
                ><chevron-left-icon class="icon"></chevron-left-icon
            ></router-link>
        </header>

        <form class="form" @submit.prevent="updateUser">
            <div class="formGroup">
                <label>First name</label>
                <input data-cy="first_name" type="text" v-model="form.first_name" />
                <has-error data-cy="error_first_name" :form="form" field="first_name"></has-error>
            </div>

            <div class="formGroup">
                <label>Last name</label>
                <input data-cy="last_name" type="text" v-model="form.last_name" />
                <has-error :form="form" data-cy="error_last_name" field="last_name"></has-error>
            </div>

            <div class="formGroup">
                <label>Date of birth</label>
                <input type="date" v-model="form.dob" />
            </div>

            <div class="formGroup">
                <label>Gender</label>
                <select v-model="form.gender">
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                </select>
            </div>

            <div class="formGroup">
                <label>Email address</label>
                <input data-cy="email" type="email" v-model="form.email" />
                <has-error :form="form" field="email" data-cy="error_email"></has-error>
            </div>

            <div class="formGroup">
                <label>Contact telephone</label>
                <phone-number-field
                    v-model="form.phone"
                    class="dark-mode"
                    :auto-pick-country-code="false"
                    required
                ></phone-number-field>
            </div>

            <div class="formGroup">
                <label>Timezone</label>
                <select
                    name="timezone_offset"
                    id="timezone-offset"
                    v-model="form.timezone"
                    style="margin-top: 5px"
                >
                    <option value="" disabled>Please select a timezone</option>
                    <option value="-12:00">(GMT -12:00) Eniwetok, Kwajalein</option>
                    <option value="-11:00">(GMT -11:00) Midway Island, Samoa</option>
                    <option value="-10:00">(GMT -10:00) Hawaii</option>
                    <option value="-09:50">(GMT -9:30) Taiohae</option>
                    <option value="-09:00">(GMT -9:00) Alaska</option>
                    <option value="-08:00">(GMT -8:00) Pacific Time (US &amp; Canada)</option>
                    <option value="-07:00">(GMT -7:00) Mountain Time (US &amp; Canada)</option>
                    <option value="-06:00">
                        (GMT -6:00) Central Time (US &amp; Canada), Mexico City
                    </option>
                    <option value="-05:00">
                        (GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima
                    </option>
                    <option value="-04:50">(GMT -4:30) Caracas</option>
                    <option value="-04:00">
                        (GMT -4:00) Atlantic Time (Canada), Caracas, La Paz
                    </option>
                    <option value="-03:50">(GMT -3:30) Newfoundland</option>
                    <option value="-03:00">(GMT -3:00) Brazil, Buenos Aires, Georgetown</option>
                    <option value="-02:00">(GMT -2:00) Mid-Atlantic</option>
                    <option value="-01:00">(GMT -1:00) Azores, Cape Verde Islands</option>
                    <option value="+00:00">
                        (GMT) Western Europe Time, London, Lisbon, Casablanca
                    </option>
                    <option value="+01:00">(GMT +1:00) Brussels, Copenhagen, Madrid, Paris</option>
                    <option value="+02:00">(GMT +2:00) Kaliningrad, South Africa</option>
                    <option value="+03:00">
                        (GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg
                    </option>
                    <option value="+03:50">(GMT +3:30) Tehran</option>
                    <option value="+04:00">(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi</option>
                    <option value="+04:50">(GMT +4:30) Kabul</option>
                    <option value="+05:00">
                        (GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent
                    </option>
                    <option value="+05:50">(GMT +5:30) Bombay, Calcutta, Madras, New Delhi</option>
                    <option value="+05:75">(GMT +5:45) Kathmandu, Pokhara</option>
                    <option value="+06:00">(GMT +6:00) Almaty, Dhaka, Colombo</option>
                    <option value="+06:50">(GMT +6:30) Yangon, Mandalay</option>
                    <option value="+07:00">(GMT +7:00) Bangkok, Hanoi, Jakarta</option>
                    <option value="+08:00">(GMT +8:00) Beijing, Perth, Singapore, Hong Kong</option>
                    <option value="+08:75">(GMT +8:45) Eucla</option>
                    <option value="+09:00">
                        (GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk
                    </option>
                    <option value="+09:50">(GMT +9:30) Adelaide, Darwin</option>
                    <option value="+10:00">
                        (GMT +10:00) Eastern Australia, Guam, Vladivostok
                    </option>
                    <option value="+10:50">(GMT +10:30) Lord Howe Island</option>
                    <option value="+11:00">
                        (GMT +11:00) Magadan, Solomon Islands, New Caledonia
                    </option>
                    <option value="+11:50">(GMT +11:30) Norfolk Island</option>
                    <option value="+12:00">
                        (GMT +12:00) Auckland, Wellington, Fiji, Kamchatka
                    </option>
                    <option value="+12:75">(GMT +12:45) Chatham Islands</option>
                    <option value="+13:00">(GMT +13:00) Apia, Nukualofa</option>
                    <option value="+14:00">(GMT +14:00) Line Islands, Tokelau</option>
                </select>
            </div>

            <div class="formGroup">
                <label>Left/Right handed</label>
                <select v-model="form.handed">
                    <option value="Left">Left</option>
                    <option value="Right">Right</option>
                </select>
            </div>

            <div class="formGroup">
                <label>Shoe size</label>
                <select v-model="form.shoe">
                    <option>2</option>
                    <option>2.5</option>
                    <option>3</option>
                    <option>3.5</option>
                    <option>4</option>
                    <option>4.5</option>
                    <option>5</option>
                    <option>5.5</option>
                    <option>6</option>
                    <option>6.5</option>
                    <option>7</option>
                    <option>7.5</option>
                    <option>8</option>
                    <option>8.5</option>
                    <option>9</option>
                    <option>9.5</option>
                    <option>10</option>
                    <option>10.5</option>
                    <option>11</option>
                    <option>11.5</option>
                    <option>12</option>
                    <option>12.5</option>
                    <option>13</option>
                    <option>13.5</option>
                    <option>14</option>
                    <option>14.5</option>
                    <option>15</option>
                </select>
            </div>

            <div class="formGroup" v-if="user.type == 'pro'">
                <label>Currency</label>
                <select v-model="form.currency">
                    <option value="GBP">United Kingdom Pounds</option>
                    <option value="USD">United States Dollars</option>
                    <option value="EUR">Euro</option>
                    <option value="DZD">Algeria Dinars</option>
                    <option value="ARP">Argentina Pesos</option>
                    <option value="AUD">Australia Dollars</option>
                    <option value="ATS">Austria Schillings</option>
                    <option value="BSD">Bahamas Dollars</option>
                    <option value="BBD">Barbados Dollars</option>
                    <option value="BEF">Belgium Francs</option>
                    <option value="BMD">Bermuda Dollars</option>
                    <option value="BRR">Brazil Real</option>
                    <option value="BGL">Bulgaria Lev</option>
                    <option value="CAD">Canada Dollars</option>
                    <option value="CLP">Chile Pesos</option>
                    <option value="CNY">China Yuan Renmimbi</option>
                    <option value="CYP">Cyprus Pounds</option>
                    <option value="CSK">Czech Republic Koruna</option>
                    <option value="DKK">Denmark Kroner</option>
                    <option value="NLG">Dutch Guilders</option>
                    <option value="XCD">Eastern Caribbean Dollars</option>
                    <option value="EGP">Egypt Pounds</option>
                    <option value="FJD">Fiji Dollars</option>
                    <option value="FIM">Finland Markka</option>
                    <option value="FRF">France Francs</option>
                    <option value="DEM">Germany Deutsche Marks</option>
                    <option value="XAU">Gold Ounces</option>
                    <option value="GRD">Greece Drachmas</option>
                    <option value="HKD">Hong Kong Dollars</option>
                    <option value="HUF">Hungary Forint</option>
                    <option value="ISK">Iceland Krona</option>
                    <option value="INR">India Rupees</option>
                    <option value="IDR">Indonesia Rupiah</option>
                    <option value="IEP">Ireland Punt</option>
                    <option value="ILS">Israel New Shekels</option>
                    <option value="ITL">Italy Lira</option>
                    <option value="JMD">Jamaica Dollars</option>
                    <option value="JPY">Japan Yen</option>
                    <option value="JOD">Jordan Dinar</option>
                    <option value="KRW">Korea (South) Won</option>
                    <option value="LBP">Lebanon Pounds</option>
                    <option value="LUF">Luxembourg Francs</option>
                    <option value="MYR">Malaysia Ringgit</option>
                    <option value="MXP">Mexico Pesos</option>
                    <option value="NLG">Netherlands Guilders</option>
                    <option value="NZD">New Zealand Dollars</option>
                    <option value="NOK">Norway Kroner</option>
                    <option value="PKR">Pakistan Rupees</option>
                    <option value="XPD">Palladium Ounces</option>
                    <option value="PHP">Philippines Pesos</option>
                    <option value="XPT">Platinum Ounces</option>
                    <option value="PLZ">Poland Zloty</option>
                    <option value="PTE">Portugal Escudo</option>
                    <option value="ROL">Romania Leu</option>
                    <option value="RUR">Russia Rubles</option>
                    <option value="SAR">Saudi Arabia Riyal</option>
                    <option value="XAG">Silver Ounces</option>
                    <option value="SGD">Singapore Dollars</option>
                    <option value="SKK">Slovakia Koruna</option>
                    <option value="ZAR">South Africa Rand</option>
                    <option value="KRW">South Korea Won</option>
                    <option value="ESP">Spain Pesetas</option>
                    <option value="XDR">Special Drawing Right (IMF)</option>
                    <option value="SDD">Sudan Dinar</option>
                    <option value="SEK">Sweden Krona</option>
                    <option value="CHF">Switzerland Francs</option>
                    <option value="TWD">Taiwan Dollars</option>
                    <option value="THB">Thailand Baht</option>
                    <option value="TTD">Trinidad and Tobago Dollars</option>
                    <option value="TRL">Turkey Lira</option>
                    <option value="VEB">Venezuela Bolivar</option>
                    <option value="ZMK">Zambia Kwacha</option>
                    <option value="EUR">Euro</option>
                    <option value="XCD">Eastern Caribbean Dollars</option>
                    <option value="XDR">Special Drawing Right (IMF)</option>
                    <option value="XAG">Silver Ounces</option>
                    <option value="XAU">Gold Ounces</option>
                    <option value="XPD">Palladium Ounces</option>
                    <option value="XPT">Platinum Ounces</option>
                </select>
            </div>

            <div class="form-group">
                <button
                    data-cy="updateUser"
                    class="button"
                    :disabled="form.busy"
                    type="submit"
                    name="button"
                >
                    {{ form.busy ? "Please wait..." : "Update" }}
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import { Form, HasError } from "vform";
import { ChevronLeftIcon } from "vue-feather-icons";
export default {
    name: "personal",
    components: { HasError, ChevronLeftIcon },
    data() {
        return {
            form: new Form({
                first_name: "",
                last_name: "",
                dob: "",
                gender: "",
                email: "",
                phone: "",
                timezone: "",
                handed: "",
                shoe: "",
                currency: "",
            }),
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    mounted() {
        this.form.fill(this.$store.state.user);

        if (this.$store.state.user.dob) {
            this.form.dob = this.$date(this.$store.state.user.dob).format("YYYY-MM-DD");
        }
    },
    methods: {
        updateUser() {
            this.form.put("/user/" + this.user.id).then((user) => {
                this.$store.dispatch("updateUser", user.data);
                this.$notify({
                    text: "Your details have been updated",
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
